export const translationConfig = {
  common: ['CommonUI.Features', 'Common.GameSorts', 'Feature.PlacesList'],
  feature: 'Feature.GamePage'
};

export default translationConfig;
